import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'plus', 'Plus', [["path",{"d":"M12 5l0 14","key":"svg-0"}],["path",{"d":"M5 12l14 0","key":"svg-1"}]]);